import { ArrowRight, Sparkles } from "lucide-react";

export const CTABanner = () => (
  <section className="bg-[#0b2545] py-10" data-testid="cta-banner">
    <div className="max-w-6xl mx-auto px-6 lg:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
      <div>
        <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-[#14B8A6]">Diagnostica gratuita · 2 minuti · Quotazioni OMI ufficiali</p>
        <h3 className="mt-1 text-xl sm:text-2xl font-display font-semibold text-white">La tua casa è pronta per il mercato o resterà invenduta per mesi?</h3>
      </div>
      <a href="/valutazione" data-testid="cta-banner-btn"
        className="group inline-flex items-center gap-2.5 px-6 py-3 rounded-md bg-[#14B8A6] text-[#06222b] font-semibold text-sm hover:bg-[#0d9488] hover:text-white transition-colors">
        Inizia la Diagnostica <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
      </a>
    </div>
  </section>
);

export const MobileStickyCTA = () => (
  <a href="/valutazione" data-testid="mobile-sticky-cta"
    className="md:hidden fixed bottom-0 inset-x-0 z-50 flex items-center justify-center gap-2 bg-[#14B8A6] text-[#06222b] font-bold text-sm py-3.5 shadow-[0_-4px_20px_rgba(11,37,69,0.25)]">
    <Sparkles className="w-4 h-4" /> Inizia la Diagnostica GRATIS — 2 minuti
  </a>
);
